import { request } from '@src/core/api/request';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEYS } from '@shared/constants/query-keys';

import type { TMember } from '../types/member';
import { useAuthStore } from '@src/core/store/auth-store';

export const getMeData = async (): Promise<TMember> => {
  return request({ url: 'members/me/' });
};

export const useGetMe = (options?: Partial<UseQueryOptions<TMember>>) => {
  const { accessToken } = useAuthStore();

  const data = useQuery({
    queryKey: [QUERY_KEYS.getMe],
    queryFn: getMeData,
    enabled: !!accessToken,
    staleTime: Infinity,
    ...options,
  });

  return data;
};
